import { render, staticRenderFns } from "./m_describeimage.vue?vue&type=template&id=32728976&scoped=true&"
import script from "./m_describeimage.vue?vue&type=script&lang=js&"
export * from "./m_describeimage.vue?vue&type=script&lang=js&"
import style0 from "./m_describeimage.vue?vue&type=style&index=0&id=32728976&scoped=true&lang=css&"
import style1 from "./m_describeimage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32728976",
  null
  
)

export default component.exports